namespace $.$$ {

	$mol_style_define( $shm_dashboard_admin_user_add, {
		maxWidth: '480px',

		Body_content: {
			padding: 0,
			gap: $mol_gap.block,
		},

		Submit: {
			// alignSelf: 'flex-start',
			margin: $mol_gap.block,
		},
	} )

}
